import React from 'react';
export const asyncComponent = (componentName, importer) => {
    const LazyComponent = React.lazy(async () => {
        const component = (await importer())[componentName];
        return { default: component };
    });
    const asyncComponent = (props) => (React.createElement(React.Suspense, { fallback: null },
        React.createElement(LazyComponent, { ...props })));
    asyncComponent.displayName = `Async${componentName}`;
    return asyncComponent;
};
//# sourceMappingURL=suspense.preenvesnextjs.map
